import type { ReactNode } from 'react';

export function Modal({ id, title, onClose, children }: { id: string; title: string; onClose?: () => void; children: ReactNode }) {
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" id={id} onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        {children}
      </div>
    </div>
  );
}
